module.exports = __webpack_public_path__ + "static/media/industry-agriculture.91921046.jpg";